const IAAvatarBlock = ({ children }) => {
    return(
        <div className="iron-avatar d-flex justify-content-center align-items-center">
            {children}
        </div>
    );
}

export default IAAvatarBlock;